import React from 'react';
import { Paper, Box, IconButton, Typography, Link, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import BusinessIcon from '@mui/icons-material/Business';
import InventoryIcon from '@mui/icons-material/Inventory';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import BuildIcon from '@mui/icons-material/Build';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ApprovalIcon from '@mui/icons-material/Approval';
import DomainIcon from '@mui/icons-material/Domain';
import TitleBreadCrumbsContainer from '../../../containers/common/breadcurmbs/TitleBreadCrumbsContainer';
import ActionButtons from '../buttons/ActionButtons';

const getTitleIcon = (icon) => {
  switch (icon) {
    case 'partner':
      return <BusinessIcon />;
    case 'product':
      return <InventoryIcon />;
    case 'user':
      return <AccountCircleIcon />;
    case 'taxbill':
      return <ReceiptIcon />;
    case 'pay':
      return <PriceCheckIcon />;
    case 'chance':
      return <AccountTreeIcon />;
    case 'tech':
      return <BuildIcon />;
    case 'dashboard':
      return <DashboardIcon />;
    case 'approval':
      return <ApprovalIcon />;
    case 'depart':
      return <DomainIcon />;

    default:
      return '';
  }
};

const TitleBox = ({
  edit,
  remove,
  isInitPwd,
  menuName,
  titleData,
  menuLink,
  handleEdit,
  handleRemove,
  handleInitPwd,
  handleGoBack,
  icon,
  editBtnText,
  editDelText,
}) => {
  return (
    <>
      <Paper
        sx={{
          backgroundColor: '#fafafa',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'stretch', sm: 'center' },
            gap: { xs: 1, sm: 0 },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'center',
              minWidth: 0,
            }}
          >
            <Box sx={{ px: 1 }}>
              <IconButton size="small" onClick={handleGoBack}>
                <ArrowBackIcon aria-label="goBack" />
              </IconButton>
            </Box>

            <Box
              sx={{
                py: 1,
                flexGrow: 1,
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
                minWidth: 0,
              }}
            >
              <Box
                sx={{
                  mx: 1,
                  color: '#fff',
                  bgcolor: 'info.main',
                  borderRadius: 1,
                  p: 0.3,
                }}
              >
                {getTitleIcon(icon)}
              </Box>

              <Box sx={{ ml: { xs: 1, md: 2 }, minWidth: 0 }}>
                <TitleBreadCrumbsContainer title={menuName} />
                <Typography
                  variant="subtitle1"
                  component="div"
                  color="primary.main"
                  sx={{ wordBreak: 'break-word' }}
                >
                  {titleData?.name}
                </Typography>
              </Box>
            </Box>
          </Box>
          <ActionButtons
            edit={edit}
            remove={remove}
            isInitPwd={isInitPwd}
            handleEdit={handleEdit}
            handleRemove={handleRemove}
            handleInitPwd={handleInitPwd}
            editBtnText={editBtnText}
            editDelText={editDelText}
          />
        </Box>
      </Paper>
    </>
  );
};

export default TitleBox;
